import type {
  ComputeNoCertificateCases,
  ComputerNoCertificateCasesReturn,
} from "./Shield.types";

export const computeNoCertificateCases = ({
  isShieldRejected,
  isTariffShieldFormClose,
}: ComputeNoCertificateCases): ComputerNoCertificateCasesReturn => {
  if (isShieldRejected) {
    return { reason: "notElegible", status: "error" };
  }
  if (isTariffShieldFormClose) {
    return { reason: "notPossible", status: "error" };
  }
  return { reason: "possible", status: "success" };
};
